import React from 'react';
import { ScrollReveal } from './ScrollReveal';
export function TestimonialsSection() {
  return <section className="py-32 bg-[#1a1a1a] text-white relative overflow-hidden" data-id="element-457">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-458">
        <div className="absolute -top-40 -right-40 w-[40rem] h-[40rem] bg-[#3b7780] rounded-full mix-blend-screen filter blur-[100px] opacity-20" data-id="element-459"></div>
        <div className="absolute -bottom-40 -left-40 w-[40rem] h-[40rem] bg-[#59d0d4] rounded-full mix-blend-screen filter blur-[100px] opacity-10" data-id="element-460"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-461">
        <ScrollReveal variant="up" data-id="element-462">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-463">
            <h2 className="text-2xl md:text-5xl font-extrabold mb-6 tracking-tight" data-id="element-464">
              Testimonials unserer Kursteilnehmer
            </h2>
            <p className="text-base sm:text-xl text-[#748282] font-medium" data-id="element-465">
              Erfahren Sie aus erster Hand, wie unsere Fortbildungen den
              Praxisalltag unserer Teilnehmer nachhaltig bereichert haben.
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal variant="scale" delay={200} data-id="element-466">
          <div className="max-w-5xl mx-auto" data-id="element-467">
            <div className="relative rounded-3xl overflow-hidden shadow-[0_0_50px_rgba(89,208,212,0.15)] aspect-video bg-black border border-slate-800 group" data-id="element-468">
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/V_zrU15q3j0?si=Tl3qjyMHOKAFMSbu" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-469"></iframe>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}